import axios from 'axios';

export const GET_SERVICE_TYPES = 'GET_SERVICE_TYPES';
export const ADD_SERVICE_TYPE = 'ADD_SERVICE_TYPE';
export const EDIT_SERVICE_TYPE = 'EDIT_SERVICE_TYPE';
export const DELETE_SERVICE_TYPE = 'DELETE_SERVICE_TYPE';
export const SET_VARIABLES_SERVICE_TYPES = "SET_VARIABLES_SERVICE_TYPES";
export const GET_SINGLE_SERVICE_TYPE = "GET_SINGLE_SERVICE_TYPE"; /* if necessary, you can load the single type from array */

export const GET_SERVICE_TYPES_CLIENT = 'GET_SERVICE_TYPES_CLIENT';
export const ADD_SERVICE_TYPE_CLIENT = 'ADD_SERVICE_TYPE_CLIENT';
export const EDIT_SERVICE_TYPE_CLIENT = 'EDIT_SERVICE_TYPE_CLIENT';
export const DELETE_SERVICE_TYPE_CLIENT = 'DELETE_SERVICE_TYPE_CLIENT';

export const GET_SERVICE_TYPES_ITEM = 'GET_SERVICE_TYPES_ITEM';
export const ADD_SERVICE_TYPE_ITEM = 'ADD_SERVICE_TYPE_ITEM';
export const EDIT_SERVICE_TYPE_ITEM = 'EDIT_SERVICE_TYPE_ITEM';
export const DELETE_SERVICE_TYPE_ITEM = 'DELETE_SERVICE_TYPE_ITEM';

export function getServiceTypesR() {
  return {
    type: GET_SERVICE_TYPES,
    payload: axios.get('/api/servicetypes/list.json').then(({ data }) => data),
  };
}

export function getSingleServiceTypeR(serviceTypeId) {
  return {
    type: GET_SINGLE_SERVICE_TYPE,
    payload: axios.get('/api/servicetypes/'+ serviceTypeId +'/view.json ').then(({ data }) => data),
  };
}


export function editServiceTypeR(serviceTypeId, data) {
  return {
    type: EDIT_SERVICE_TYPE,
    payload:   axios.put('/api/servicetypes/'+ serviceTypeId +'.json', data).then(({ data }) => data),
  };
}


export function addServiceTypeR(data) {
  return {
    type: ADD_SERVICE_TYPE,
    payload:   axios.post('/api/servicetypes.json', data).then(({ data }) => data),
  };
}

export function deleteServiceTypeR(serviceTypeId) {
  return {
    type: DELETE_SERVICE_TYPE,
    payload:   axios.delete('/api/servicetypes/'+ serviceTypeId +'.json').then(({ data }) => data),
  };
}


export function setVariablesSubscription(key, id){
  let data = [key, id]
  return{
    type: SET_VARIABLES_SERVICE_TYPES,
    payload: data,
  }
}

export function getServiceTypesClientR(client = '') {
  let link = '/api/servicetypes/commissions/list.json';
  if (client.length>0){
    link = '/api/servicetypes/commissions/list.json?filters%5Bclient%5D='+ client;
  }
  return {
    type: GET_SERVICE_TYPES_CLIENT,
    payload: axios.get(link).then(({ data }) => data),
  };
}

export function addServiceTypeClientR(data) {
  return {
    type: ADD_SERVICE_TYPE_CLIENT,
    payload:   axios.post('/api/servicetypes/commissions.json', data).then(({ data }) => data),
  };
}

export function editServiceTypeClientR(serviceTypeId, data) {
  return {
    type: EDIT_SERVICE_TYPE_CLIENT,
    payload:   axios.put('/api/servicetypes/commissions/'+ serviceTypeId +'.json', data).then(({ data }) => data),
  };
}


export function deleteServiceTypeClientR(serviceTypeId) {
  return {
    type: DELETE_SERVICE_TYPE_CLIENT,
    payload:   axios.delete('/api/servicetypes/commissions/'+ serviceTypeId +'.json').then(({ data }) => data),
  };
}


export function getServiceTypesItemR(item = '') {
  let link = '/api/servicetypes/item/commissions/list.json';
  if (item.length>0){
    link = '/api/servicetypes/item/commissions/list.json?filters%5Bitem%5D='+ item;
  }
  return {
    type: GET_SERVICE_TYPES_ITEM,
    payload: axios.get(link).then(({ data }) => data),
  };
}

export function addServiceTypeItemR(data) {
  return {
    type: ADD_SERVICE_TYPE_ITEM,
    payload:   axios.post('/api/servicetypes/item/commissions.json', data).then(({ data }) => data),
  };
}

export function editServiceTypeItemR(serviceTypeId, data) {
  return {
    type: EDIT_SERVICE_TYPE_ITEM,
    payload:   axios.put('/api/servicetypes/item/commissions/'+ serviceTypeId +'.json', data).then(({ data }) => data),
  };
}


export function deleteServiceTypeItemR(serviceTypeId) {
  return {
    type: DELETE_SERVICE_TYPE_ITEM,
    payload:   axios.delete('/api/servicetypes/item/commissions/'+ serviceTypeId +'.json').then(({ data }) => data),
  };
}
